import { getUserNameByUserId } from '../getUserNameByUserId'

export const LENDER_SOURCES: MortgageDocumentRequirementSource[] = ['LENDER_VIA_DIP', 'LENDER_VIA_MARKETPLACE']
export const USER_SOURCES: (MortgageDocumentRequirementSource | CaseDocumentRequirementSource)[] = [
  'USER',
  'USER_VIA_MESSAGE',
]

const getSelectedMortgage = (caseDetails: Maybe<Case>) =>
  (caseDetails?.mortgages || []).find(({ status }) => status === 'STATUS_SELECTED')

export const findMatchingCaseDocumentRequirement = (verificationId: Maybe<string>, caseDetails: Maybe<Case>) =>
  verificationId
    ? (caseDetails?.document_requirements ?? []).find((r) => r.requirement_id === verificationId)
    : undefined

export const findMatchingMortgageDocumentRequirement = (verificationId: Maybe<string>, caseDetails: Maybe<Case>) =>
  verificationId
    ? (getSelectedMortgage(caseDetails)?.document_requirements ?? []).find((r) => r.requirement_id === verificationId)
    : undefined

export const getDocRequirementSourceName = (
  verification: Verification,
  caseDetails: Case,
  users: Maybe<User[]>,
  regulatedByOrg: Maybe<Organisation>,
): string => {
  const selectedMortgage = getSelectedMortgage(caseDetails)

  const matchingDocRequirement =
    findMatchingMortgageDocumentRequirement(verification.verification_id, caseDetails) ??
    findMatchingCaseDocumentRequirement(verification.verification_id, caseDetails)

  const isRequiredByLender = Boolean(
    matchingDocRequirement?.source && LENDER_SOURCES.includes(matchingDocRequirement?.source),
  )

  const isRequiredByUser = Boolean(
    matchingDocRequirement?.source && USER_SOURCES.includes(matchingDocRequirement?.source),
  )

  if (isRequiredByLender) {
    return selectedMortgage?.mortgage_product?.lender_name ?? ''
  }

  if (isRequiredByUser) {
    return getUserNameByUserId(users, matchingDocRequirement?.source_id)
  }

  return regulatedByOrg?.name ?? ''
}
